import PropTypes from 'prop-types';

const Checkbox = ({
    id,
    name,
    handleChange,
    isSelected = false,
    checkBoxLabel,
    hideLabel,
    checkBoxDisable = false,
    isError = false,
    checkBoxLabelPos = 'right',
    labelClassName = '',
    register
}) => (
    <>
        <div
            className={`relative inline-flex items-center cursor-pointer ${
                checkBoxLabelPos === 'left' ? 'flex-row-reverse' : ''
            } ${checkBoxDisable && 'pointer-events-none'}`}
        >
            <input
                id={id}
                type="checkbox"
                className="accent-primary-800 active:accent-green-600 h-5 w-5 flex-shrink-0"
                onChange={handleChange}
                {...register('agreedTerms')}
                checked={isSelected}
                name={name}
            />
            <span
                className={`text-sm text-neutral-900 ${labelClassName} ${
                    checkBoxLabelPos === 'left' ? 'mr-2' : 'ml-2'
                }`}
            >
                {!hideLabel ? checkBoxLabel : ''}
            </span>
        </div>
    </>
);

export default Checkbox;

Checkbox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    handleChange: PropTypes.func,
    isSelected: PropTypes.bool,
    isError: PropTypes.bool,
    value: PropTypes.string,
    checkBoxLabel: PropTypes.string,
    hideLabel: PropTypes.bool,
    checkBoxDisable: PropTypes.bool,
    checkBoxLabelPos: PropTypes.oneOf(['left', 'right'])
};
